import { Directive, ElementRef, EventEmitter, HostListener, OnInit, Output } from '@angular/core';

@Directive({
  selector: '[appOutSideClick]'
})
export class OutSideClickDirective implements OnInit {

  // SEND DATA
  @Output()
  outsideClick: EventEmitter<MouseEvent> = new EventEmitter();
  @Output()
  insideClick: EventEmitter<MouseEvent> = new EventEmitter();

  constructor(
    private elementRef: ElementRef
  ) { }

  ngOnInit(): void {

  }

  // HOST LISTENER
  @HostListener('document:mousedown', ['$event'])
  onClick(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.outsideClick.emit(event);
    } else {
      this.insideClick.emit(event);
    }
  }

}
